import {useCurrentEditor} from '@tiptap/react'
import * as Icon from 'react-icons/lu'
import styled from 'styled-components'

const StyledMenuBar = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
`

const StyledActionIcon = styled.button`
  border: 1px solid #e4e6ef;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  background-color: white;
`

export const MenuBar = () => {
  const {editor} = useCurrentEditor()

  if (!editor) return null

  return (
    <StyledMenuBar>
      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editor.can().chain().focus().toggleBold().run()}
        className={editor.isActive('bold') ? 'is-active' : ''}
      >
        <Icon.LuBold />
      </StyledActionIcon>

      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!editor.can().chain().focus().toggleItalic().run()}
        className={editor.isActive('italic') ? 'is-active' : ''}
      >
        <Icon.LuItalic />
      </StyledActionIcon>

      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleStrike().run()}
        disabled={!editor.can().chain().focus().toggleStrike().run()}
        className={editor.isActive('strike') ? 'is-active' : ''}
      >
        <Icon.LuStrikethrough />
      </StyledActionIcon>

      {/* <StyledActionIcon
        onClick={() => editor.chain().focus().toggleCode().run()}
        disabled={!editor.can().chain().focus().toggleCode().run()}
        className={editor.isActive('code') ? 'is-active' : ''}
      >
        <Icon.LuCode />
      </StyledActionIcon> */}

      {/* <StyledActionIcon
        onClick={() => editor.chain().focus().setParagraph().run()}
        className={editor.isActive('paragraph') ? 'is-active' : ''}
      >
        <Icon.LuPilcrow />
      </StyledActionIcon> */}
      {/* <StyledActionIcon
        onClick={() => editor.chain().focus().toggleHeading({level: 1}).run()}
        className={editor.isActive('heading', {level: 1}) ? 'is-active' : ''}
      >
        <Icon.LuHeading1 />
      </StyledActionIcon>
      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleHeading({level: 2}).run()}
        className={editor.isActive('heading', {level: 2}) ? 'is-active' : ''}
      >
        <Icon.LuHeading2 />
      </StyledActionIcon>
      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleHeading({level: 3}).run()}
        className={editor.isActive('heading', {level: 3}) ? 'is-active' : ''}
      >
        <Icon.LuHeading3 />
      </StyledActionIcon>
      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleHeading({level: 4}).run()}
        className={editor.isActive('heading', {level: 4}) ? 'is-active' : ''}
      >
        <Icon.LuHeading4 />
      </StyledActionIcon>
      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleHeading({level: 5}).run()}
        className={editor.isActive('heading', {level: 5}) ? 'is-active' : ''}
      >
        <Icon.LuHeading5 />
      </StyledActionIcon>
      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleHeading({level: 6}).run()}
        className={editor.isActive('heading', {level: 6}) ? 'is-active' : ''}
      >
        <Icon.LuHeading6 />
      </StyledActionIcon> */}
      <StyledActionIcon
        onClick={() => editor.chain().focus().setTextAlign('left').run()}
        className={editor.isActive({textAlign: 'left'}) ? 'is-active' : ''}
      >
        <Icon.LuAlignLeft />
      </StyledActionIcon>

      <StyledActionIcon
        onClick={() => editor.chain().focus().setTextAlign('center').run()}
        className={editor.isActive({textAlign: 'center'}) ? 'is-active' : ''}
      >
        <Icon.LuAlignCenter />
      </StyledActionIcon>

      <StyledActionIcon
        onClick={() => editor.chain().focus().setTextAlign('right').run()}
        className={editor.isActive({textAlign: 'right'}) ? 'is-active' : ''}
      >
        <Icon.LuAlignRight />
      </StyledActionIcon>

      <StyledActionIcon
        onClick={() => editor.chain().focus().setTextAlign('justify').run()}
        className={editor.isActive({textAlign: 'justify'}) ? 'is-active' : ''}
      >
        <Icon.LuAlignJustify />
      </StyledActionIcon>

      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={editor.isActive('bulletList') ? 'is-active' : ''}
      >
        <Icon.LuList />
      </StyledActionIcon>
      <StyledActionIcon
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={editor.isActive('orderedList') ? 'is-active' : ''}
      >
        <Icon.LuListOrdered />
      </StyledActionIcon>
      {/* <StyledActionIcon
        onClick={() => editor.chain().focus().toggleCodeBlock().run()}
        className={editor.isActive('codeBlock') ? 'is-active' : ''}
      >
        <Icon.LuCode />
      </StyledActionIcon> */}
      {/* <StyledActionIcon
        onClick={() => editor.chain().focus().toggleBlockquote().run()}
        className={editor.isActive('blockquote') ? 'is-active' : ''}
      >
        <Icon.LuQuote />
      </StyledActionIcon> */}
      <StyledActionIcon onClick={() => editor.chain().focus().setHorizontalRule().run()}>
        <Icon.LuMinus />
      </StyledActionIcon>
      <StyledActionIcon onClick={() => editor.chain().focus().setHardBreak().run()}>
        <Icon.LuWrapText />
      </StyledActionIcon>
      <StyledActionIcon
        onClick={() => editor.chain().focus().undo().run()}
        disabled={!editor.can().chain().focus().undo().run()}
      >
        <Icon.LuUndo />
      </StyledActionIcon>
      <StyledActionIcon
        onClick={() => editor.chain().focus().redo().run()}
        disabled={!editor.can().chain().focus().redo().run()}
      >
        <Icon.LuRedo />
      </StyledActionIcon>
    </StyledMenuBar>
  )
}
